import React, { useState, useEffect } from 'react';
import './style.sass';
import ModalPortal from 'components/Modal';
import { useHistory } from 'react-router-dom'
import { deleteCardT1 } from 'services/T1Pagos'

import { ModalError } from 'components/Error/ErrorModal'
import { usePayCard } from 'hooks/usePayCard'
import { encodeStorage, decodeStorage } from 'functions/storageBase64'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import ReactDOM from 'react-dom';

//- funcion de modal de eliminar tarjeta
function MessageRemove(props) {
    const {
        remvoeAction,
        awaitAction
    } = props

    const elimiar = () => remvoeAction(true);
    const recapacitar = () => awaitAction(true);

    return (
        <div className="modalTarjetaNoAgregada">
            <p>¿Estas seguro que deseas eliminar esta tarjeta?</p>
            <div className="contBtnsEnterado">
                <div className="contBtns">
                    <div className="btnSinBorde" onClick={recapacitar}>No</div>
                    <div className="btnSinBorde" onClick={elimiar}>Si, eliminar</div>
                </div>
            </div>
        </div>
    )
}

export default function CardElegirTarjeta(props) {
    const {
        terminacion,
        nombre,
        vencimiento,
        tipoTarjeta,
        logo,
        id,
        dataCard,
        update,
        setCadrActive,
        cardActive,
        position,
        setLoading,

        setErrorCodeCard
    } = props;
    const history = useHistory();

    const [showModal, SetShowModal] = useState(false);
    const { dataPayment, successPay, errorPay } = usePayCard()
    const payCardRelation = decodeStorage('payCardRelation')
    const [cvv, setCvv] = useState()
    const [contCvv, setContCvv] = useState(false)
    const [lengthCvv, setLengthCvv] = useState(3)

    useEffect(()=>{
        if(errorPay >= 500){
            setErrorCodeCard(errorPay);
        }
    },[errorPay])

    // funciones para mostrar el modal
    const removeCard = (val) => showModalRemove()
    const showModalRemove = () => SetShowModal(true);
    const handleClose = () => SetShowModal(false);

    const noRemove = () => SetShowModal(false);

    // se ejecuta si el suario le da continuar
    const [respDelete, setRespDelete] = useState()
    const siRemove = () => {
        deleteCardT1(id)
        .then(setRespDelete)
        setRespDelete({statusCode: 200})
    };

    useEffect(() => {
        if (respDelete) {
            if (respDelete.statusCode === 200) {
                SetShowModal(false)
                update()
            } else {
                SetShowModal(false)
            }
        }
    }, [respDelete])


    const resetCardPay = () => {
        setFlagActivarCard(false);
        setCvv(null)
        setContCvv(null)
        setCadrActive()
        document.querySelector(`input[name="card_${position}"]`).checked = false
        setActeiveT(0)
    }


    const [flagActivarCard, setFlagActivarCard] = useState(false);
    const [activeT, setActeiveT] = useState(0)
    useEffect(() => {
        if (cardActive) {
            if (cardActive === id) {
                if (activeT === 0) {
                    setFlagActivarCard(true);
                    setCadrActive()
                    setActeiveT(1)
                    //console.log('asdasd-1 ')
                }
                else {
                    resetCardPay()
                }
            } else {
                resetCardPay()
            }
        }
    }, [cardActive])


    const activarCard = (e) => {
        setCadrActive(id)
    }

    const handlePagar = () => {
        if (cvv?.length >= 3) {
            dataPayment({
                idCard: id,
                cvv: cvv,
                payCardRelation: payCardRelation,
                addCard: ""
            })
            setLoading(true)
        }
    }

    const valueCvv = (e) => {
        let inputCvv = e.target.value.replace(/[^\d]+/g, '')

        if (inputCvv?.length === lengthCvv) {
            setContCvv(true)
        }
        else {
            setContCvv(false)
        }
        setCvv(inputCvv)
    }

    useEffect(() => {
        if (tipoTarjeta === "amex") {
            setLengthCvv(4)
        } else {
            setLengthCvv(3)
        }
    }, [tipoTarjeta])


    // valida pago y si no pasa manda el error
    const [errorCode, setErrorCode] = useState()
    const [messageResponse, setMessageResponse] = useState()
    const [sectionActive, setSectionActive] = useState(null)
    const [showModalErr, setShowModalErr] = useState(false);
    const handleCloseErr = () => {
        setShowModalErr(false);
        history.replace(`${BASE_PATH}${SUB_DIRECTORY}pagar/elegir-tarjeta`)
    }
    useEffect(() => {
        if (successPay) {
            encodeStorage('payCodeSuccess', successPay)
            history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar/thankYouPage`);
            setLoading(false)
        }
        else if (errorPay) {
            setShowModalErr(true)
            setErrorCode(errorPay)
            setMessageResponse(errorPay.message)
            setSectionActive('choiseCards')
            setLoading(false)
            resetCardPay()
        }
    }, [successPay, errorPay])

    const editCard = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar/editar-tarjeta-bancaria/${id}`)
    }

    return (
        <>
            <article className="cardElegir" id={id} >
                <div className="typeCard" >
                    <div className="logoCard"><img src={`${BASE_PATH}${SUB_DIRECTORY}${logo}`} alt="logo-card"></img></div>
                    <div className="titleCard">{tipoTarjeta} **** {terminacion}</div>
                    <input type="radio" name={`card_${position}`} onChange={activarCard}></input>
                </div>


                <div className="contentCardElegir">
                    <div className="dataInternal">
                        <div className="titleCard">
                            <div className="cardNombre"><p>{nombre}</p></div>
                            <div className="cardVencimiento"> <p>Vence {vencimiento}</p></div>
                        </div>

                        {flagActivarCard &&
                            <>
                                <div className="cardCVV">
                                    <input placeholder="CVV"
                                        value={cvv}
                                        minLength={lengthCvv}
                                        maxLength={lengthCvv}
                                        onChange={valueCvv}
                                    />
                                    {
                                    tipoTarjeta != "amex"
                                        ?
                                            <span>El CVV son tres números y se localizan en la parte posterior de la tarjeta.</span>
                                        :    
                                            <span>El CVV son cuatro números y se localizan en la parte frontal de la tarjeta.</span>
                                    }
                                </div>
                                <div className="cardBtnPagar">
                                    <button onClick={handlePagar} disabled={contCvv ? "" : "disabled"}>Pagar con esta tarjeta</button>
                                </div>
                                <div className="cardBtnsActions">
                                    <div className="btn blanco" onClick={removeCard}>Eliminar</div>
                                    <div className="btn blanco" onClick={editCard}>Editar</div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </article>

            {showModalErr && (errorCode <= 499 || errorCode?.codMen <=499) &&
                <ModalError
                    errorCode={errorCode}
                    section={sectionActive}
                    message={messageResponse}
                    handleClose={handleCloseErr}
                />
            }

            {showModal &&
                <ModalCardDelete type="" onClose={handleClose} >
                    <MessageRemove remvoeAction={siRemove} awaitAction={noRemove} />
                </ModalCardDelete>
            }
        </>
    )
}

export function ModalCardDelete({ ...props }) {
    const {
        children,
        onClose,
        type,
        title,
        cerrar,
        aceptar,
    } = props;

    return ReactDOM.createPortal(
        <ModalCard onClose={onClose} type={type} title={title}>
            {children}
        </ModalCard>,
        document.getElementById('modal-root')
    )
}

export function ModalCard({ ...props }) {
    const {
        children,
        onClose,
        type,
        title,
        cerrar
    } = props;

    return (
        <div className={`modal ${type}`} onClick={onClose}>
            <div className="contentModal" id="modalM">
                <div className="contentCloseMovi">
                    <div className="btn close" onClick={cerrar}></div>
                    {title ? <p className="title">{title}</p> : null}
                </div>

                <div className="dataModal">
                    {children}
                </div>
            </div>
        </div>
    )
}
